app.service('memberOrdersService', [
  '$http',
  '$q',
  function ($http, $q) {
    var limit = 24;

    this.getOrders = function (page) {
      return $http({
        method: 'GET',
        url: '/api/orders',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        params: {
          page: page,
          limit: limit,
        },
      });
    };

    this.getCheckoutObjects = function (page) {
      const deferObject = $q.defer();
      const mockCheckoutObjects = [
        {
          _id: '62e1146176ebfc00477d3b2c',
          number: '20220727103305136',
          status: 'pending',
          created_at: '2022-07-27T10:33:05.497Z',
          order_payment_status: 'pending',
          total: {
            cents: 630,
            currency_symbol: 'NT$',
            currency_iso: 'TWD',
            label: 'NT$630',
            dollars: 630.0,
          },
          orders: [
            {
              _id: '62d4ec590d78fb0039359a2c',
              order_number: '132412341234',
              status: 'pending',
              order_delivery: {
                delivery_status: 'pending',
              },
            },
            {
              _id: '62ec82d9b81f9a00415f030c',
              order_number: '123412341234',
              status: 'pending',
              order_delivery: {
                delivery_status: 'pending',
              },
            },
          ],
        },
        {
          _id: '62e1146176ebfc00477d3b2d',
          number: '20220727103305136',
          status: 'pending',
          created_at: '2022-07-27T10:33:05.497Z',
          order_payment_status: 'pending',
          total: {
            cents: 630,
            currency_symbol: 'NT$',
            currency_iso: 'TWD',
            label: 'NT$630',
            dollars: 630.0,
          },
          orders: [
            {
              _id: '62ec82d9b81f9a00415f030c',
              order_number: '132412341234',
              status: 'pending',
              order_delivery: {
                delivery_status: 'pending',
              },
            },
          ],
        },
      ];

      deferObject.resolve({
        data: {
          data: {
            limit,
            page,
            items: mockCheckoutObjects,
            total: page * limit + 1,
          },
        },
      });

      return deferObject.promise;

      // @TODO: use real api data
      // return $http({
      //   method: 'GET',
      //   url: '/api/checkout_objects',
      //   headers: { 'X-Requested-With': 'XMLHttpRequest' },
      //   params: {
      //     page: page,
      //     limit: limit,
      //   },
      // });
    };

    this.getCheckoutObject = function (checkoutObjectId) {
      const deferObject = $q.defer();
      const mockCheckoutObject = {
        _id: checkoutObjectId,
        number: '20220727103305136',
        status: 'pending',
        created_at: '2022-07-27T10:33:05.497Z',
        order_payment_status: 'pending',
        payment_gateway: 'cash_on_delivery',
        payment_method_id: '625d35e406ab4f17ef9a9a23',
        payment_status: 'pending',
        payment_fee: {
          cents: 90,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$90',
          dollars: 90.0,
        },
        total_tax_fee: {
          cents: 2,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$2',
          dollars: 2.0,
        },
        applied_user_credits: {
          cents: 3,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$3',
          dollars: 3.0,
        },
        orders: [
          {
            _id: '62d4ec590d78fb0039359a2c',
            cart_tag: {
              name_translations: { en: '', 'zh-hant': 'cart tag A' },
              priority: 1,
            },
            order_delivery: {
              _id: '',
              total: {
                cents: 10,
                currency_symbol: 'NT$',
                currency_iso: 'TWD',
                label: 'NT$10',
                dollars: 10.0,
              },
            },
          },
          {
            _id: '62ec82d9b81f9a00415f030c',
            cart_tag: {
              name_translations: { en: '', 'zh-hant': '' },
              priority: 2,
            },
            order_delivery: {
              _id: '',
              total: {
                cents: 20,
                currency_symbol: 'NT$',
                currency_iso: 'TWD',
                label: 'NT$20',
                dollars: 20.0,
              },
            },
          },
        ],
        total: {
          cents: 600,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$600',
          dollars: 600.0,
        },
        subtotal: {
          cents: 600,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$600',
          dollars: 600.0,
        },
        order_discount: {
          total: {
            cents: 40,
            currency_symbol: 'NT$',
            currency_iso: 'TWD',
            label: 'NT$40',
            dollars: 40.0,
          },
        },
        member_point_summary: {
          redeemed_points: 30,
          pending_days: 2,
          earned_points: 3,
          order_created_by: 'shop',
          order_type: null,
        },
        auto_reward_credit_summary: {
          auto_reward_rule_id: '62c28899f73e39004b5c6371',
          accumulated_type: 'credit',
          is_accumulated: true,
          credit_threshold: 'NT$400',
          credit_value: 'NT$50',
          triggered: true,
          calculate_credit_value: 'NT$50',
          auto_reward_balance: 'NT$-220',
        },
        applied_member_point: 400,
        applied_member_point_redeem_to_cash: {
          cents: 40,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$40',
          dollars: 40.0,
        },
        custom_discount_items: [
          {
            item_data: {
              name: 'test customer discount',
            },
            total: {
              cents: 30,
              currency_symbol: 'NT$',
              currency_iso: 'TWD',
              label: 'NT$30',
              dollars: 30.0,
            },
          },
        ],
        custom_discount: {
          cents: 30,
          currency_symbol: 'NT$',
          currency_iso: 'TWD',
          label: 'NT$30',
          dollars: 30.0,
        },
        promotion_items: [
          {
            promotion_id: '62cfd1a8274d9000f23',
            summary_translations: {
              en: 'buy 3 cheaper test',
              'zh-hant': '3個更划算',
            },
            _id: '62cfd1a8274d9000fa1325d2',
            discounted_amount: {
              cents: -200,
              currency_symbol: 'NT$',
              currency_iso: 'TWD',
              label: '-NT$200',
              dollars: -200.0,
            },
          },
          {
            promotion_id: '62cfd1a8274d90002ivb',
            summary_translations: {
              en: '滿千折百 ENG',
              'zh-hant': '滿千折百',
            },
            coupon_code: 'GOGO123',
            _id: '62cfd1a8274d9000fa1325d2',
            discounted_amount: {
              cents: 0,
              currency_symbol: 'NT$300',
              currency_iso: 'TWD',
              label: '-NT$300',
              dollars: 0.0,
            },
          },
        ],
        rounding_difference_items: [
          {
            status: '',
            positive: '',
            total: {
              cents: 40,
              currency_symbol: 'NT$',
              currency_iso: 'TWD',
              label: 'NT$40',
              dollars: 40.0,
            },
          },
        ],
      };

      setTimeout(() => {
        deferObject.resolve({
          data: { data: mockCheckoutObject },
        });
      }, 1000);

      return deferObject.promise;

      // @TODO: use real api data
      // return $http({
      //   method: 'GET',
      //   url: `/api/checkout_objects/${checkoutObjectId}`,
      //   headers: { 'X-Requested-With': 'XMLHttpRequest' },
      // });
    };
  },
]);
